<template>
  <div >
    <el-drawer @reload="$reloadHandle" title="关闭工单" size="40%" :before-close="handleClose" :visible.sync="drawer"
      direction="rtl" append-to-body  custom-class="demo-drawer" ref="drawer" class="details2">

      <div class="demo-drawer__content">



        <template>
          <div>
            <div class="detail-wrap">
              <el-form ref="editForm" :model="formData">
                <div class="d-header">
                  <div class=""  style="padding: 5px;border-bottom: 1px solid #ededed">
                    <i class="el-icon-info" style="color: #00c4b3;" />
                    <!-- {{ dataId ? '查看' : '新增' }}工单 -->
                    工单号：<span style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{ formData.orderNo }}</span>
                    <!-- 服务类型 -->
                    <span class="information">{{ formData.serverTypeName}}</span>
                    <!-- 工单状态 -->
                    <span class="information">
                      {{formData.stat == '1'?'登记':formData.stat == '2'?'发布':formData.stat == '5'?'已派网点':formData.stat == '9'?'已派师傅':formData.stat == '13'?'已出发':formData.stat == '17'?'已上门':formData.stat == '20'?'完工暂存':formData.stat == '21'?'已完工':formData.stat == '22'?'网点确定完工':formData.stat == '23'?'中心确定完工':formData.stat == '24'?'总部确定完工':formData.stat == '91'?'待结算':formData.stat == '92'?'结算驳回':formData.stat == '93'?'结算中止':formData.stat == '94'?'已结算':formData.stat == '98'?'挂起':'取消'}}</span>
                    <!-- 紧急度 -->
                    <span class="information" v-if="formData.urger==0">一般</span>
                    <span class="information" v-else-if="formData.urger==1">紧急</span>
                    <span class="information" v-else-if="formData.urger==2">特急</span>
                    <span class="information" v-else>未知</span>
                  </div>
                </div>
                <el-form-item label="关闭原因" :prop="returnType" >
                  <el-select v-model="formData.returnId" style="width: 8vw;" @change="changeReturnType($event)"  ref ="returnId" clearable filterable>
                    <el-option v-for="item in returnData" :key="item.id" :label="item.returnName"
                               :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="关闭备注" :label-width="formLabelWidth">
                  <el-input type="textarea"
                            :autosize="{ minRows: 4, maxRows: 8}" v-model="formData.remark" autocomplete="off"></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </template>
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="closeOrder">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

    <!-- 关闭弹窗 -->

  </div>
</template>
<script>
import request from "@/router/axios";
  export default {
    inject: ['reload'],
    name: 'edit',
    props: ['multi','orderId' ],
    components: {

    },
    created(){this.dataId=this.orderId
    },
    data() {
      return {
        show3: false,
        dataId: '',
        form2: {
          desc: '',
          name: "",
        },
        showOrderPop: false,

        drawer: true,
        formData: {},
        srcList: [],
        returnData:{},
      }
    },
    mounted() {
      this.getData();
      this.getReturnType();
    },
    methods: {
        getData() {
          //获取对应的工单信息
          request({
            url: '/basic/soOrder/getById',
            method: 'post',
            data: {
              id: this.dataId
            },
            isLoading: true,
            modalStrictly: true,
          }).then(response => {
            this.formData = response.data.data;
            this.formData.orderId = this.dataId;
          })
      },
      getReturnType(){
        request({
          url: '/basic/basReturnType/getLists',
          method: 'post',
          data: {
            returnDisrect:2,
            usable: 1,
            orderId: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.returnData = response.data.data;
        })
      },
      // 工单弹窗选中
      orderCommit(row) {
        console.log(row, '弹窗数据')
        this.formData.orderNo = row.orderNo
        this.formData.orderId = row.orderId
      },
      shut() {
        // this.showOrderPop=true
      },
      closeOrder() {
        if(!this.formData.remark){
          this.$message.error("请输入关闭备注")
          return
        }
        this.$mask.open()

        request({
          url: '/basic/soOrderDispatch/closeOrder',
          method: 'post',
          data:this.formData,
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          if(response.data.type == "success"){
            this.$message({ message:response.data.content,type: 'success'});
            this.drawer = false;
            clearTimeout(this.timer);
            this.$emit('closeOrderRemark', 1)
          }else{
            this.$message({ message:response.data.content,type: 'warning'});
          }
        })
        this.$mask.close()

      },
      cancelForm() {
        this.drawer = false;
        clearTimeout(this.timer);
        this.$emit('closeOrderRemark', 0)
      },
      changeReturnType(row){
        let returnName =  this.$refs.returnId.selected.label;
        this.$set(this.formData, 'remark', returnName);
      },
      handleClose() {

        this.drawer = false;
        this.$emit('closeOrderRemark', 0)
      }
    }
  }
</script>
<style lang="scss" scoped>
.details2{

  ::v-deep .el-drawer .el-drawer__body {
    padding: 0 16px;
    background-color: #fff;
    position: relative;
  }

  ::v-deep .el-drawer .el-drawer__header {
    background-color: #fff;
  }

  ::v-deep .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: aliceblue;
    background-color: rgb(38 38 38 / 70%);
  }

  #containt .table-detail {
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #ededed;
  }

  .btn {
    text-align: center;
  }
//   3个标签
.information {
    padding: 0px 10px;
    background-color: #E1F2FF;
    color: #268AEA;
    border-radius: 3px;
    margin: 0 5px;
    font-size: 15px;
  }
//   每个分支
.d-item {
  border: 1px solid #ededed;
  padding-bottom: 5px;

  .title b {
    display: inline-block;
    line-height: 20px;
    font-size: 13px;
    font-weight: 600;
    margin-right: 84px;
    vertical-align: middle;
    color: rgb(42, 100, 148);
    position: relative;
    z-index: 2;
    background: rgba(42, 100, 148, 0.16);
    margin-left: 0px;
    margin-bottom: 8px;
    padding-left: 12px;
    padding-right: 14px;
    border-radius: 0px 28px 28px 0px;
}
.table-detail tr {
    margin-bottom: 10px;
    display: block;
th {
    font-weight: 400;
    text-align: right;
    width: 7vw !important;
    font-size: 12px;
    position: relative;
    padding: 0 5px 0 4px;
    color: rgba(86, 86, 86, 0.96);
}
td {
    font-weight: 400;
    // text-align: right;
    width: 10vw !important;
    font-size: 12px;
    position: relative;
    padding: 0 0px 0 4px;
    color: rgba(0, 0, 0,);
}
}}

::v-deep .el-image__preview {
    width: 60px !important;
    height: 60px !important;
  }

  .pic_main {
    display: flex;
    margin-left: 20px;
    margin-top: 10px;

    .pic_item {
      display: flex;
      margin-right: 40px;

      span {
        white-space:nowrap;
        line-height: 60px;
        font-size: 12px;
        color: rgba(86, 86, 86, 0.96);
        font-weight: 400;

      }
    }
  }

  // 本单费用位置
  .expense {
    position: absolute;
    right: 20%;
    margin-top: 5px;
    color: #00c4b3;
    font-size: 13px;
  }
  // 滚动条样式

  /* 滚动条 */
  ::-webkit-scrollbar {
    width: 5px;
    height: 12px;
  }

  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    border-radius: 0px;
    // background: rgba(224, 7, 7, 0.05);
  }

  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 00px;
    background: #cfcece;
  }

  // 步骤条 圆的位置
  ::v-deep .el-timeline-item__node--normal {
    left: 0px !important;
    width: 12px;
    height: 12px;
  }
 ::v-deep  .el-step__title {
    font-size: 13px!important;
    line-height: 38px;
}
}
</style>
